import createDependenciesScope from '@/scopes/common/infrastructure/dependencies/createDependenciesScope';
import type { PDPStore } from '@/scopes/products/infrastructure/store';
import type { StoreApi } from 'zustand';

export interface PDPDependencies {
  pdpStore: StoreApi<PDPStore>;
}

const { Provider, useDependency } = createDependenciesScope<PDPDependencies>();

export const PDPDependenciesProvider = Provider;
export const usePDPDependency = useDependency;
